import { render, staticRenderFns } from "./canvas.vue?vue&type=template&id=69ad332d&scoped=true&"
import script from "./canvas.vue?vue&type=script&lang=js&"
export * from "./canvas.vue?vue&type=script&lang=js&"
import style0 from "./canvas.vue?vue&type=style&index=0&id=69ad332d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad332d",
  null
  
)

export default component.exports